import { render, staticRenderFns } from "./ReferrerSecondPage.vue?vue&type=template&id=2edc0b78&scoped=true"
import script from "./ReferrerSecondPage.vue?vue&type=script&lang=js"
export * from "./ReferrerSecondPage.vue?vue&type=script&lang=js"
import style0 from "./ReferrerSecondPage.vue?vue&type=style&index=0&id=2edc0b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edc0b78",
  null
  
)

export default component.exports